import { Identifiable, ProjectReport } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByGroups(
  report: Identifiable<ProjectReport>,
  { groups }: Filter,
) {
  return (
    !!groups &&
    groups.length > 0 &&
    !groups.find(
      (group) =>
        !!group.resources.find((resource) => resource.name === report.name),
    )
  );
}

export { isFilteredByGroups };
